import FieldConfig from "../../../fields3/proto/field-config"
import {FieldType} from "../../../fields3/field-type"
import FieldsCollection from "../../../fields3/collection/base/fields-collection"
import {EntityType} from "../../../gd/const/item"
import {ColumnID, SystemColumnType} from "../../../gd-modules/manager/columns/types"
import FieldProto from "../../../fields3/proto/field-proto"
import FieldMessagesTotal from "../../../fields3/generic/total/messages/messages-total"
import FieldAttachmentsTotal from "../../../fields3/generic/total/attachments/attachments-total"
import FieldCurrency from "../../../fields3/generic/finance/currency/currency"
import FieldStoryPoints from "../../../fields3/generic/story-points/story-points"
import FieldItemModelTimeReportedCalculated
    from "../../../fields3/system/item-model/time-reported-calculated/time-reported-calculated"
import FieldItemModelCalculatedSpentEstimate
    from "../../../fields3/system/item-model/calculated-spent-estimate/calculated-spent-estimate"
import CustomFieldsManager from "../../../gd/manager/custom-fields-manager"
import Field1ToField2Converter from "../../../fields3/fields-converter-1-2"
import FieldsFactory from "../../../fields3/fields-factory"
import FieldStatus from "../../../fields3/generic/status/status"
import FieldEstimate from "../../../fields3/generic/estimate/estimate"
import FieldDateRange from "../../../fields3/generic/datetime/date-range/date-range"
import FieldDate from "../../../fields3/generic/datetime/date/date"
import FieldNumber from "../../../fields3/generic/number/number"
import FieldProgress from "../../../fields3/generic/progress/progress"
import FieldNumberOfTasks from "../../../fields3/system/group/number-of-tasks/number-of-tasks"
import FieldGroupReportedByUsers from "../../../fields3/system/group/reported-by-users/reported-by-users"

const baseConfig: FieldConfig[] = [
    {
        fieldId         : 'statusId',
        type            : FieldType.GROUP_STATUS
    },
    {
        fieldId         : 'reportedByUsersIds',
        type            : FieldType.GROUP_REPORTED_BY_USERS,
    },
    {
        fieldId         : 'estimate',
        type            : FieldType.GROUP_ESTIMATE
    },
    {
        fieldId         : 'estimatedCostInternal',
        type            : FieldType.CURRENCY,
    },
    {
        fieldId         : 'estimatedCostExternal',
        type            : FieldType.CURRENCY,
    },
    {
        fieldId         : 'messagesTotal',
        type            : FieldType.MESSAGES_TOTAL,
    },
    {
        fieldId         : 'attachmentsTotal',
        type            : FieldType.ATTACHMENTS_TOTAL,
    },
    {
        fieldId         : 'costInternal',
        type            : FieldType.CURRENCY,
        isDisabled      : true,
    },
    {
        fieldId         : 'costExternal',
        type            : FieldType.CURRENCY,
        isDisabled      : true,
    },
    {
        fieldId         : 'storyPoints',
        type            : FieldType.STORY_POINTS,
    },
    {
        fieldId         : 'reportedTime',
        type            : FieldType.ITEM_MODEL_CALCULATED_TIME_REPORTS,
    },
    {
        fieldId         : 'calculatedExpenses',
        type            : FieldType.CURRENCY,
    },
    {
        fieldId         : 'spentEstimate',
        type            : FieldType.ITEM_MODEL_CALCULATED_SPENT_ESTIMATE,
    },
    {
        fieldId         : 'startEnd',
        type            : FieldType.PROJECT_START_END,
    },
    {
        fieldId         : 'deadline',
        type            : FieldType.DATE,
    },
    {
        fieldId         : 'scheduleDate',
        type            : FieldType.DATE,
    },
    {
        fieldId         : 'startDate',
        type            : FieldType.DATE,
    },
    {
        fieldId         : 'endDate',
        type            : FieldType.DATE,
    },
    {
        fieldId         : 'momentCreated',
        type            : FieldType.DATE,
    },
    {
        fieldId         : 'latestActivityMoment',
        type            : FieldType.DATE,
    },
    {
        fieldId         : 'momentClosed',
        type            : FieldType.DATE,
    },
    {
        fieldId         : 'durationCalendar',
        type            : FieldType.NUMBER,
    },
    {
        fieldId         : 'durationWorkdays',
        type            : FieldType.NUMBER,
    },
    {
        fieldId         : 'progress',
        type            : FieldType.PROJECT_PROGRESS,
    },
    /*{
        fieldId         : 'progressTasks',
        type            : FieldType.PROJECT_PROGRESS_TASKS,
    },*/
    {
        fieldId         : 'numberOfTasks',
        type            : FieldType.GROUP_NUMBER_OF_TASKS,
    },
]

export default class GroupFields extends FieldsCollection {

    private isCompanyManager: boolean = false

    constructor() {

        const fieldsConfig = baseConfig
        // we can modify base config with params in constructor if needed

        super(fieldsConfig, EntityType.GROUP);

        this.isCompanyManager = gd.ac.check.company.isManager(gd.companyId)
        this.initAllCustomFields()
    }

    getByColumnId(columnId: ColumnID): FieldProto | undefined {

        const ProjectFieldsColumnToFieldMap: Partial<Record<SystemColumnType, FieldProto | undefined>> = {
            [SystemColumnType.REPORTED_BY]                      : this.reportedByUsersIds,
            [SystemColumnType.STATUS]                           : this.statusId,
            [SystemColumnType.STORY_POINTS]                     : this.storyPoints, //gd.fields.itemModel.calculatedStoryPoints,
            [SystemColumnType.ESTIMATE]                         : this.estimate, //gd.fields.itemModel.calculatedEstimated,
            [SystemColumnType.TIME_REPORTED]                    : this.reportedTime, //gd.fields.itemModel.calculatedTimeReports,
            [SystemColumnType.SPENT_ESTIMATE]                   : this.spentEstimate, //gd.fields.itemModel.calculatedSpentEstimated,
            [SystemColumnType.ITEM_MODEL_CALCULATED_EXPENSES]   : this.calculatedExpenses, //gd.fields.itemModel.calculatedExpenses,
            [SystemColumnType.COST_INTERNAL]                    : this.costInternal, //gd.fields.itemModel.calculatedLaborCost,
            [SystemColumnType.COST_EXTERNAL]                    : this.costExternal, //gd.fields.itemModel.calculatedServiceCost,
            [SystemColumnType.ESTIMATED_COST_INTERNAL]          : this.estimatedCostInternal,
            [SystemColumnType.ESTIMATED_COST_EXTERNAL]          : this.estimatedCostExternal,
            [SystemColumnType.MESSAGES_TOTAL]                   : this.messagesTotal,
            [SystemColumnType.ATTACHMENTS_TOTAL]                : this.attachmentsTotal,
            [SystemColumnType.START_END_DATE]                   : this.startEnd,
            [SystemColumnType.DEADLINE]                         : this.deadline,
            [SystemColumnType.SCHEDULE]                         : this.scheduleDate,
            [SystemColumnType.START_DATE]                       : this.startDate,
            [SystemColumnType.END_DATE]                         : this.endDate,
            [SystemColumnType.DATE_CREATED]                     : this.momentCreated,
            [SystemColumnType.LAST_UPDATED]                     : this.latestActivityMoment,
            [SystemColumnType.DATE_CLOSED]                      : this.momentClosed,
            [SystemColumnType.DURATION_CALENDAR_DAYS]           : this.durationCalendar,
            [SystemColumnType.DURATION_WORK_DAYS]               : this.durationWorkdays,
            [SystemColumnType.PROGRESS_BAR]                     : this.progress,
            // [SystemColumnType.PROGRESS_TASKS]                   : this.progressTasks, // projects only, but groups has no projects
        }

        return ProjectFieldsColumnToFieldMap[columnId as SystemColumnType]
    }

    get reportedByUsersIds()            : FieldGroupReportedByUsers { return this.get('reportedByUsersIds') as FieldGroupReportedByUsers }
    get statusId()                      : FieldStatus { return this.get('statusId') as FieldStatus}
    get estimatedCostInternal()         : FieldCurrency { return this.get('estimatedCostInternal') as FieldCurrency}
    get estimatedCostExternal()         : FieldCurrency { return this.get('estimatedCostExternal') as FieldCurrency}
    get estimate()                      : FieldEstimate { return this.get('estimate') as FieldEstimate }
    get messagesTotal()                 : FieldMessagesTotal { return this.get('messagesTotal') as FieldMessagesTotal}
    get attachmentsTotal()              : FieldAttachmentsTotal { return this.get('attachmentsTotal') as FieldAttachmentsTotal}
    get costInternal()                  : FieldCurrency { return this.get('costInternal') as FieldCurrency}
    get costExternal()                  : FieldCurrency { return this.get('costExternal') as FieldCurrency}
    get storyPoints()                   : FieldStoryPoints { return this.get('storyPoints') as FieldStoryPoints}
    get reportedTime()                  : FieldItemModelTimeReportedCalculated { return this.get('reportedTime') as FieldItemModelTimeReportedCalculated}
    get calculatedExpenses()            : FieldCurrency { return this.get('calculatedExpenses') as FieldCurrency}
    get spentEstimate()                 : FieldItemModelCalculatedSpentEstimate { return this.get('spentEstimate') as FieldItemModelCalculatedSpentEstimate}
    get startEnd()                      : FieldDateRange { return this.get('startEnd') as FieldDateRange}
    get deadline()                      : FieldDate { return this.get('deadline') as FieldDate}
    get scheduleDate()                  : FieldDate { return this.get('scheduleDate') as FieldDate}
    get startDate()                     : FieldDate { return this.get('startDate') as FieldDate}
    get endDate()                       : FieldDate { return this.get('endDate') as FieldDate}
    get momentCreated()                 : FieldDate { return this.get('momentCreated') as FieldDate}
    get latestActivityMoment()          : FieldDate { return this.get('latestActivityMoment') as FieldDate}
    get momentClosed()                  : FieldDate { return this.get('momentClosed') as FieldDate}
    get durationCalendar()              : FieldNumber { return this.get('durationCalendar') as FieldNumber}
    get durationWorkdays()              : FieldNumber { return this.get('durationWorkdays') as FieldNumber}
    get progress()                      : FieldProgress { return this.get('progress') as FieldProgress}
    // get progressTasks()                 : FieldProjectProgressTasks { return this.get('progressTasks') as FieldProjectProgressTasks }
    get numberOfTasks()                 : FieldNumberOfTasks { return this.get('numberOfTasks') as FieldNumberOfTasks}

    private isCustomFieldAvailable = (customField:any): boolean => {
        return (this.isCompanyManager || customField.access === gd.const.customFields.access.EVERYONE) &&
            // _.intersection(customField.params.scope, [gd.const.customFields.scope.PROJECT]).length > 0 &&
            !customField.isDeleted
    }

    public addCustomField(customField:any) {
        if (!this.isCustomFieldAvailable(customField)) return

        const field2Config = Field1ToField2Converter.getField2Config(customField.id)
        if (field2Config                                                // field config successfully created
            && !this.hasField(field2Config.fieldId)                     // field with same ID does not exist in this (ProjectFields) fields collection
            && gd.session.customFields.get(field2Config?.fieldId)) {    // custom field exists in session
            // @ts-ignore
            this.addField(FieldsFactory.get(field2Config))
        }
    }

    public initAllCustomFields() {
        const customFields = CustomFieldsManager.getOrganizationCustomFields(gd.companyId, [gd.const.customFields.scope.PROJECT])
        _.map(customFields, customField=>{
            this.addCustomField(customField)}
        )
    }
}
